import { Plugin } from '@nuxt/types';

type migrateFn = (email: string, password: string, metadata: any) => Promise<void>;
type resetPwdFn = (email: string, token: string, newPassword: string) => Promise<void>;

interface UniversalLoginPlugin {
  $universalLoginMigrate: migrateFn;
  $universalLoginResetPassword: resetPwdFn;
}
declare module '@nuxt/types' {
  interface Context extends UniversalLoginPlugin {}
}

const universalLoginPlugin: Plugin = ({ $axios, $config }, inject) => {
  const migrate: migrateFn = async (email, password, metadata) => {
    try {
      await $axios.post(
        'user/v1/accounts/migrate',
        {
          email,
          password,
          metadata,
        },
        {
          baseURL: $config.universalLoginURL,
        }
      );
    } catch (error) {
      console.error('Migration failed:', error);
      throw error;
    }
  };

  const resetPassword: resetPwdFn = async (email, token, newPassword) => {
    try {
      await $axios.post(
        'user/v1/accounts/reset-password',
        {
          email,
          token,
          newPassword,
        },
        {
          baseURL: $config.universalLoginURL,
        }
      );
    } catch (error) {
      console.error('Reset password failed:', error);
      throw error;
    }
  };

  inject('universalLoginMigrate', migrate);
  inject('universalLoginResetPassword', resetPassword);
};

export default universalLoginPlugin;
